import { useTranslation } from 'react-i18next'

// Language names are shown in their own language, so they need no translation.
const LANGUAGES = [
  { code: 'pt', label: 'PT', name: 'Português' },
  { code: 'en', label: 'EN', name: 'English' },
] as const

interface LanguageSwitcherProps {
  variant?: 'footer' | 'navbar'
  className?: string
}

const VARIANT_STYLES = {
  footer: {
    button: 'px-2 py-0.5 text-xs rounded',
    active: 'bg-tabby-orange text-white font-semibold',
    idle: 'text-golden-beige/60 hover:text-tabby-orange',
  },
  navbar: {
    button: 'min-w-9 min-h-9 px-2 text-sm rounded-lg font-semibold',
    active: 'bg-golden text-my-black',
    idle: 'text-golden hover:bg-golden/15',
  },
} as const

export function LanguageSwitcher({ variant = 'footer', className = '' }: LanguageSwitcherProps) {
  const { i18n } = useTranslation()

  const current = i18n.resolvedLanguage?.slice(0, 2) ?? 'pt'
  const styles = VARIANT_STYLES[variant]

  return (
    <div className={`flex items-center gap-1 ${className}`} role="group" aria-label="Idioma / Language">
      {LANGUAGES.map((lang) => (
        <button
          key={lang.code}
          type="button"
          onClick={() => i18n.changeLanguage(lang.code)}
          className={`${styles.button} transition-colors duration-200 ${
            current === lang.code ? styles.active : styles.idle
          }`}
          aria-label={lang.name}
          aria-pressed={current === lang.code}
          lang={lang.code}
        >
          {lang.label}
        </button>
      ))}
    </div>
  )
}
